
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.932 9.338c-.415.96-.876 2.036-1.044 2.461a.49.49 0 01-.244-.05c-.276-.121-.44-.358-.44-.56V8.962a.6.6 0 00-.6-.6H2.556c-.02 0-.134-.025-.264-.226-.125-.195-.164-.407-.145-.521.047-.293.227-1.367.407-2.447v-.002l.001-.006c.18-1.081.362-2.165.41-2.467.015-.087.083-.207.252-.319.169-.11.383-.174.57-.174H8.68v4.934l.001.048v.428l-.016.037-.176.405-.557 1.287zm1.75-1.021l-.092.213c-.147.338-.347.798-.556 1.284-.422.976-.876 2.039-1.033 2.435a1.16 1.16 0 01-.858.724c-.341.071-.69.002-.981-.125-.564-.247-1.158-.837-1.158-1.658V9.56H2.556c-.595 0-1.031-.402-1.272-.775-.246-.38-.4-.89-.322-1.366.048-.295.228-1.37.407-2.447l.002-.012.41-2.462c.084-.512.416-.89.775-1.128.36-.238.804-.373 1.232-.373h7.356A1.8 1.8 0 0112.945 2.8v3.733a1.8 1.8 0 01-1.8 1.801H9.88c-.068 0-.134-.005-.199-.016zm.2-1.184h1.262a.6.6 0 00.6-.6V2.798a.6.6 0 00-.6-.6H9.882v4.934z","fill":"#AF1731"}})])
          )
        }
      }
    